module.exports = "/fonts/maths.svg?904b2846bbf36a31a54046090969e9b9";


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/maths.svg
// module id = 2Vxc
// module chunks = 3